"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recursiveSetObjectValue = void 0;
const jsonpath_plus_1 = require("jsonpath-plus");
const recursiveSetObjectValue = (originalObject, keyPath, value) => {
    // if we are the original path string, call ourself with the path array
    if (typeof keyPath === 'string') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore Not defined properly in types apparently
        const pathParts = jsonpath_plus_1.JSONPath.toPathArray(keyPath);
        return (0, exports.recursiveSetObjectValue)(originalObject, pathParts, value);
    }
    else {
        const [currentPath, ...rest] = keyPath;
        let newObject;
        if (!originalObject || Array.isArray(originalObject)) {
            const possibleNumber = Number.parseInt(currentPath);
            if (Number.isInteger(possibleNumber) && possibleNumber >= 0) {
                const index = possibleNumber;
                const originalArray = Array.isArray(originalObject) ? [...originalObject] : [];
                const newValue = keyPath.length === 1 ? value : (0, exports.recursiveSetObjectValue)(originalArray[index], rest, value);
                return [...originalArray.slice(0, index), newValue, ...originalArray.slice(index + 1)];
            }
        }
        if (!Array.isArray(originalObject)) {
            newObject = Object.assign({}, originalObject);
            if (keyPath.length === 1) {
                newObject[currentPath] = value;
            }
            else if (currentPath === '$') {
                return (0, exports.recursiveSetObjectValue)(newObject, rest, value);
            }
            else if (keyPath.length > 1) {
                newObject[currentPath] = (0, exports.recursiveSetObjectValue)((originalObject || {})[currentPath], rest, value);
            }
        }
        return newObject;
    }
};
exports.recursiveSetObjectValue = recursiveSetObjectValue;
//# sourceMappingURL=RecursiveSetObjectValue.js.map